import { Directive, input } from '@angular/core';

@Directive({
  selector: '[mbsFormTitleClasses]',
  host: {
    '[class]': 'titleClasses()'
  }
})
export class FormTitleClassesDirective {
  public readonly titleClasses = input<string>('');
}
